// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { VERSION } from './version';

export const environment = {
  production: true,
  BASE_URL: "https://api-cex.citybackoffice.com",
  ADYEN_KEY: "10001|94AB35E303168CF49BD91CD1615DD0A17AFFA2199006843192D3877B1330C7159EDFE95E49BC89294CF458A0D49C66591A43D73DB45603EF55EF490A5C8220BC7F70308C26672500E5F35F9F2F04C27CA14A0F14A926A4304A02CB3574AD257174A7811B911B36DA44B86A903EC063B88B003A38741078D9BC0D7B52EBA5CDED946AB10D5C28FCF36C4BCEF18FDBB6DD58E34861E3683F142EA862A7229C58A10D9A032055A3D8FF17DF63E77D7C4FBCFE0E2C0FA5A464EE5622C67FBFB9439C1184B55FB5DCD8968DAACB08271918DFC118CC4B1893464EAEF39C43EBF28D7C659834A1DCE4A99047CCCDB155AF4CEF4950B11A66AD52A052FD2FD911F2654B",
  ADYEN: 'https://live.adyen.com/hpp/cse/js/4114871615843182.shtml',
  ADYEN_MULTI: 'https://live.adyen.com/hpp/skipDetails.shtml',
  BASE_DOMAIN: 'https://cityexpert.travel',
  CSS_CE_IMAGES: "https://d2i7eq829tbbje.cloudfront.net/",
  ROUTE_IMAGES: "https://d3rhqa464i8zgs.cloudfront.net/",
  STOP_IMAGES: "https://d2p26ounl9rg8o.cloudfront.net/",
  LOCATION_IMAGES: "https://d3hrj27b4bz3ky.cloudfront.net/",
  OPTION_IMAGES: "https://d2esq3p4bn6sts.cloudfront.net/",
  POI_IMAGES: "https://d1u3oqfn5jdztm.cloudfront.net/",
  APP_VERSION: VERSION.version.concat(VERSION.hash),
  PACKAGE_VERSION: VERSION.version,
  GOOGLE_KEY: "AIzaSyBRxy__uXpm4e_8Qxu7-qP2t7mdTxfYdnw",
  mapbox: {
    accessToken: 'pk.eyJ1IjoicmxvemFubyIsImEiOiJjangxc3NjNGIwYzk0NDltcXBiYzhvY2h4In0.8-BNc6raonIr6oQ1ldlmvA'
 }
};
